// Check-off celebration styles. Pure data so web and native share the list.
export const CELEBRATION_STYLES = [
  'classic',
  'burst',
  'flame',
  'applause',
  'hearts',
  'surprise',
] as const
export type CelebrationStyle = (typeof CELEBRATION_STYLES)[number]

export const CELEBRATION_ICON: Record<CelebrationStyle, string> = {
  classic: '🔥',
  burst: '🎉',
  flame: '☄️',
  applause: '👏',
  hearts: '💖',
  surprise: '🎲',
}

export const FREE_CELEBRATIONS: readonly CelebrationStyle[] = ['classic', 'burst']

// Styles "surprise" picks from.
export const SURPRISE_POOL: readonly CelebrationStyle[] = ['burst', 'flame', 'applause', 'hearts']

export function resolveCelebration(style: CelebrationStyle | undefined, isPro: boolean) {
  const s = style ?? 'classic'
  const allowed = isPro || FREE_CELEBRATIONS.includes(s) ? s : 'classic'
  return allowed === 'surprise'
    ? SURPRISE_POOL[Math.floor(Math.random() * SURPRISE_POOL.length)]
    : allowed
}
